import * as  React from 'react';
import {PaginationDefaultParams} from "@components/custom/Paginator";
import {RequestData} from '@models/axios';
import debounce from 'lodash/debounce';
import packageApi from "@api/package";
import {SyntheticEvent} from 'react';

interface SelectionProps {
  count: number;
  data: any[];
  fetchRequest: (requestData: RequestData) => any;
  fetchItemsPickerDataSuccess: (requestData: RequestData) => any;
  location: object;
  type: string
}

const packageFetcherHoc = <P extends object>(Component: React.ComponentType<P>) =>
  class Selection extends React.Component<P & SelectionProps> {
    
    constructor(props) {
      super(props);
      this.fetchData = debounce(this.fetchData, 800);
    }
    
    state = {
      currentPage: 1,
      data: [],
      count: 0
    };
    
    filter = {};
    
    isFetched = false;
    
    paginationParams = PaginationDefaultParams;
    
    fetchData = (params: object = {}) => {
      packageApi.getList({
          params: {
            ...this.paginationParams,
            ...this.filter,
            ...this.props.filter || {}
          }
        })
        .then(({data}) => this.onFetchData(data))
        .catch(() => {
        
        })
    };
    
    //TODO server should response in the same pattern {data, meta}
    onFetchData = (data) => {
      this.isFetched = true;
      this.setState({
        data: this.paginationParams.offset == 0 ? data : [...this.state.data, ...data],
        // count: meta.total_count
      })
    };
    
    resetPagination = () => {
      this.paginationParams = PaginationDefaultParams;
    };
    
    handleSearch = query => {
      this.filter = {
        query
      };
      this.resetPagination();
      this.fetchData();
    };
    
    handleChange = value => {
      this.setState({
        value,
      });
    };
    
    onScroll = (e: SyntheticEvent) => {
      e.persist();
      const {data, count} = this.state;
      let target = e.target;
      if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
        if (count > data.length) {
          const offset = this.paginationParams.offset + PaginationDefaultParams.count;
          this.paginationParams = {
            offset: offset,
            count: PaginationDefaultParams.count
          };
          this.fetchData()
        }
      }
    };
    
    render() {
      const {forwardedRef, ...rest} = this.props;
      return (
        <Component ref={forwardedRef}
                   {...rest}
                   handleSearch={this.handleSearch}
                   handleChange={this.handleChange}
                   onScroll={this.onScroll}
                   data={this.state.data}
                   count={this.state.count}
                   isFetched={this.isFetched}
                   fetchData={this.fetchData}/>
      )
    }
  };

export default packageFetcherHoc;